export enum FactoryNodeInterfaceParameterBehaviorType {
    Standard = "Standard",
    Subject = "Subject",
    BehaviorSubject = "BehaviorSubject",
    Observable = "Observable",
}